import React, { FC } from 'react';
import { Row, Col } from 'antd';
import cx from 'classnames';

import { useDirection } from '~/hooks';
import '~/pages/onboarding/styles.less';

const OnboardingLayout: FC<{ className?: string }> = (props) => {
  const { children, className } = props;
  const [direction] = useDirection();

  return (
    <Row
      className={cx(`Onboarding-Layout Onboarding-Layout__${direction} Country`, className)}
      align="middle"
    >
      <Col flex="0 1 500px">{children}</Col>
    </Row>
  );
};

export default OnboardingLayout;
